import React from 'react';
import PropTypes from 'prop-types';
import Shift from './shift';

const TimeLine = ({ shifts, isW2, isMobile }) => {
    return (
        <div className="time-line">
            <div className="time-line-background" />
            <div className="time-line-shifts">
                {shifts.map((shift, i) => {
                    const isPrewLong = i === 0 || (i > 0 && shifts[i - 1].minutes > 44);
                    const displaytime = !isMobile && isW2 && (isPrewLong || (i > 0 && shifts[i - 1].type === 'toStart'));
                    return (
                        <Shift
                            key={i}
                            displaytime={displaytime}
                            className={shift.type}
                            timeIn={shift.time_in}
                            mins={shift.minutes}
                            color={shift.color}
                            projectName={shift.projectName}
                        />
                    );
                })}
            </div>
        </div>
    );
};

TimeLine.propTypes = {
    shifts: PropTypes.array,
    isW2: PropTypes.bool,
    isMobile: PropTypes.bool
};

export default TimeLine;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/timeLine.jsx